export default "__VITE_ASSET__DVChlBj8__"